const isDemoAccount = loggedInUser =>
  loggedInUser &&
  loggedInUser["user"] &&
  loggedInUser["user"]["demo_account"] &&
  loggedInUser["user"]["demo_account"];

export default isDemoAccount;
